import PieChartItemModel from './PieChartItemModel';

const PieChartElementModel = {
  elements: [PieChartItemModel],
};

export default PieChartElementModel;
